module.exports = __webpack_public_path__ + "img/educacao-fund-i.1bd31cd9.png";